<template>
  <CRow>
    <CCol col="12" lg="12">
      <CCard no-header>
        <CCardBody>
          <div class="row">
            <div class="col-6">
              <CInput readonly :label="$t('fields.name')" type="text" placeholder="Ej: Producto" v-model="product.name"></CInput>
            </div>
            <div class="col-6">
              <CInput readonly :label="$t('fields.price')" type="text" prepend="$" placeholder="Ej: 25.50" v-model="product.price"></CInput>
            </div>
          </div>
          <div class="row mb-3" v-if="productUrl !== ''">
            <div class="col-12">
              <img :src="product.image">
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <CButton v-if="permissions.delivery_types.edit" color="success" @click="editProduct">
                <CIcon :content="$options.editIcon" /> {{ $t('button.edit') }}
              </CButton>
              <CButton color="primary" @click="goBack">
                <CIcon :content="$options.backIcon" /> {{ $t('button.back') }}
              </CButton>
            </div>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';
import formMixin from '../../mixins/form';
import localeMixin from '../../mixins/locale'; // Order matters, mixin first then i18n.
import i18n from "../../i18n";
import { cilPencil, cilArrowLeft } from '@coreui/icons';

export default {
  name: 'FormProduct',
  mixins: [formMixin, localeMixin],
  editIcon: cilPencil,
  backIcon: cilArrowLeft,
  data() {
    return {
        product: {
          name: '',
          price: '',
          image: ''
        },
        productUrl: ''
    }
  },
  computed: {
    ...mapState({
      permissions: state => state.permissions,
    })
  },
  mounted() {
    if (this.isEditing) {
        this.getProduct();
    }
  },
  methods: {
    goBack() {
      this.$router.push({ name: "Products" });
    },
    editProduct() {
      const id = this.$route.params.id;
      this.$router.push({ name: 'EditProduct', params: {id} });
    },
    getProduct() {
        const id = this.$route.params.id;
        axios.get('/api/products/'+ id + '?token=' + localStorage.getItem("api_token"))
        .then(response => {
            const data = response.data;
            this.product.name = data.name;
            this.product.price = data.price;
            this.productUrl = data.imageUrl;
        }).catch(error => {
            console.log(error);
            this.$router.push({ path: '/login' });
        });
    },
  }
}

</script>

<style scoped>
.card-body img {
  width: 200px;
  height: 200px
}
</style>